import * as React from 'react';
interface ScreenHeaderContextValue {
  actions: React.ReactNode | null;
  setActions: React.Dispatch<React.SetStateAction<React.ReactNode | null>>;
}

const ScreenHeaderContext = React.createContext<ScreenHeaderContextValue | undefined>(undefined);

export function ScreenHeaderProvider({
  children,
  value,
}: {
  children: React.ReactNode;
  value: ScreenHeaderContextValue;
}) {
  return <ScreenHeaderContext.Provider value={value}>{children}</ScreenHeaderContext.Provider>;
}

export function useScreenHeader() {
  const context = React.useContext(ScreenHeaderContext);
  if (!context) {
    throw new Error('useScreenHeader must be used within a ScreenHeaderProvider');
  }
  return context;
}
